import { render } from "./BankAccountUpdate.vue?vue&type=template&id=d5371aae"
import script from "./BankAccountUpdate.vue?vue&type=script&lang=js"
export * from "./BankAccountUpdate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__